import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";

const Inventories = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;


    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div className="col-6 h-100 justify-content-center align-items-center d-flex border-left">
                    <div className="justify-content-end mt-2 d-flex">
                        <a href="/Listing/Inventories/List" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1 align-self-end justify-self-end" >
                            {t("viewAcceptedWarehouses")}
                            <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                            </span>
                        </a>
                    </div>
                </div>
                <div className="col-6 h-100 justify-content-center align-items-center d-flex">
                    <div className="justify-content-end mt-2 d-flex">
                        <a href="/Listing/Inventories/Announcement" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1 align-self-end justify-self-end" >
                            {t("viewWarehouseNotices")}
                            <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Inventories;
